<p-sidebar class="create-full" [(visible)]="appService.showNewProject"  position="right" [style]="{width:'100vw'}" [showCloseIcon]="false">
    <app-new-project *ngIf="appService.showNewProject"></app-new-project>
</p-sidebar>
<p-sidebar class="create-full" [(visible)]="appService.showNewExercise"  position="right" [style]="{width:'100vw'}" [showCloseIcon]="false">
    <app-new-exercise *ngIf="appService.showNewExercise" [project]="appService._projectExercise"></app-new-exercise>
</p-sidebar>
<div class="layout-container" [ngClass]="containerClass">
    <!-- <app-sidebar></app-sidebar> -->
    <app-topbar></app-topbar>
    <div class="layout-content-wrapper" #layout>

        <!-- <app-breadcrumb class="content-breadcrumb"></app-breadcrumb> -->
        <div class="layout-content">
            <router-outlet></router-outlet>
        </div>
    </div>
    <app-profilemenu></app-profilemenu>
    <!-- <app-config></app-config> -->
    <div class="layout-mask"></div>
</div>
